// envs manager

const envVars = import.meta.env;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const envs: ImportMetaEnv = {
  NODE_ENV: envVars?.['NODE_ENV'] || envVars?.['MODE'],
  ...envVars,
};
